import { useEffect } from "react";
import {
  PushNotificationSchema,
  PushNotifications,
  Token,
  ActionPerformed
} from "@capacitor/push-notifications";
import { useHistory } from "react-router";
import { useUsersStore } from "../stores/users.store";
import { updateAccount } from "../lib/firebase";
import toast from "react-hot-toast";
import { Capacitor } from "@capacitor/core";
// import { FCM } from "@capacitor-community/fcm";

const PushListener: React.FC = () => {
  const history = useHistory();
  const user = useUsersStore(state => state.user);
  useEffect(() => {
    if (
      Capacitor.isNativePlatform() &&
      user?.notificationPreferences?.receiveNotifications
    ) {
      PushNotifications.checkPermissions().then(res => {
        if (res.receive !== "granted") {
          PushNotifications.requestPermissions().then(res => {
            if (res.receive === "denied") {
              toast.error("Push Notification permission denied");
            } else {
              toast.success("Push Notification permission granted");
              register();
            }
          });
        } else {
          register();
        }
      });
    } else if (
      Capacitor.isNativePlatform() &&
      user?.notificationPreferences?.receiveNotifications === false
    ) {
      PushNotifications.removeAllListeners();
      updateAccount(user?.userId, {
        notificationPreferences: {
          ...user?.notificationPreferences,
          pushToken: ""
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const register = () => {
    console.log("Initializing Push Notifications");

    // Register with Apple / Google to receive push via APNS/FCM
    PushNotifications.register();

    // On success, we should be able to receive notifications
    PushNotifications.addListener("registration", async (tkn: Token) => {
      let token: any = tkn.value;
      // Get FCM token instead the APN one returned by Capacitor
      // if (Capacitor.getPlatform() === 'ios') {
      //   const { token: fcm_token } = await FCM.getToken()
      //   token = fcm_token
      // }
      // Work with FCM_TOKEN
      if (user) {
        updateAccount(user?.userId, {
          notificationPreferences: { pushToken: token }
        });
        console.log(`Push registration success, token: ${token}`);
      }
    });

    // Some issue with our setup and push will not work
    PushNotifications.addListener("registrationError", (error: any) => {
      console.warn("Error on registration: " + JSON.stringify(error));
    });

    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener(
      "pushNotificationReceived",
      (notification: PushNotificationSchema) => {
        console.log(`foreground ${JSON.stringify(notification)} `);
      }
    );

    // Method called when tapping on a notification
    PushNotifications.addListener(
      "pushNotificationActionPerformed",
      (action: ActionPerformed) => {
        if (action?.notification?.data?.bot) {
          history.push(`/bots/${action?.notification.data?.bot}`);
        } else if (action?.notification?.data?.lobby) {
          history.push(`/lobbies/${action?.notification.data?.lobby}`);
        }
      }
    );
  };

  return null;
};

export default PushListener;
